<template>
  <!-- Modal -->
  <b-modal id="depositViaATM" centered hide-footer>
    <template #modal-title>
      NẠP QUA ATM<span v-if="settings.discount_atm > 0">
        TẶNG {{ settings.discount_atm }}%</span>
    </template>
    <div class="d-block text-center">
      <div class="form-group" v-if="!create_qr_code && website.toggle_payment_code">
        <label class="text-danger"><b>Vui lòng nhập số tiền muốn nạp</b></label>
        <div class="input-group">
          <input type="number" class="form-control" v-model="value_send" placeholder="Vui lòng điền số tiền">
          <button class="btn btn-primary" @click="createQrBank">
                Tạo lệnh nạp
          </button>
        </div>
      </div>
      <!-- <div class="form-group" v-else>
        <button class="btn btn-primary btn-block" @click="refreshTransCode" v-if="website.toggle_payment_code">
              Tạo lệnh nạp mới
        </button>
      </div> -->
      <table class="table table-bordered">
        <tr>
          <td colspan="2" class="w-50">
            <b>
              {{ website.bank_account || "Setting in Shop" }}
              <i @click="copyToClipBoard(website.bank_account)" class="ti-layers"></i>
            </b>
          </td>
          <td v-if="add_info && website.toggle_payment_code"><b>Nội dung chuyển khoản <sup class="text-warning">(*)</sup></b></td>
          <td v-if="!website.toggle_payment_code"><b>Nội dung chuyển khoản <sup class="text-warning">(*)</sup></b></td>
        </tr>
        <tr>
          <td>
            <b>{{ website.bank_name || "Vietcombank" }} <i @click="copyToClipBoard(website.bank_name)" class="ti-layers"></i></b>
          </td>
          <td>
            <b>{{ website.bank_number || "11111111" }} <i @click="copyToClipBoard(website.bank_number)" class="ti-layers"></i></b>
          </td>
          <td v-if="add_info && website.toggle_payment_code">
            <strong class="text-danger" id="napbank">
              {{ add_info }} <i @click="copyToClipBoard(add_info)" class="ti-layers"></i>
            </strong>
          </td>
          <td v-if="!website.toggle_payment_code">
            <strong class="text-danger" id="napbank">
              {{website.charge_prefix}}{{ user.id ? user.id : '{ID của bạn}' }} <i @click="copyToClipBoard(`${website.charge_prefix}${user.id ? user.id : '{Id của bạn}'}`)" class="ti-layers"></i>
            </strong>
          </td>
        </tr>
      </table>

      <div class="alert alert-danger" role="alert" v-if="!create_qr_code && website.toggle_payment_code">
        Vui lòng nhập <b>số tiền</b> và <b>Tạo lệnh nạp</b> để hiển thị <b>mã giao dịch</b>
      </div>

      <div v-if="website.bank_name && website.bank_number && create_qr_code">
        <img v-if="user" :src="create_qr_code"/>
      </div>
      <div v-if="!website.toggle_payment_code">
        <img v-if="user" :src="`https://img.vietqr.io/image/${website.bank_name.toLowerCase()}-${website.bank_number}-print.jpg?addInfo=${website.charge_prefix + user.id}`"/>
      </div>

      <div class="form-group" v-if="create_qr_code && website.toggle_payment_code">
        <button class="btn btn-success btn-block" @click="checkDepositSuccess">
          Xác nhận đã thanh toán <b>{{ Helper.formatMoney(value_send) }}đ</b>
        </button>
      </div>

      <p class="deposit-des-txt" v-if="!website.popup_bank_content">
        <strong style="color: blue"
          >Hệ thống nạp tự động, vui lòng kiểm tra kỹ ATM trước khi chuyển
          :</strong
        >
        <br />
        Bước 1: Nhập số tài khoản nhận tiền
        <br />
        Bước 2 : Chọn đúng tên ngân hàng
        <br />
        Bước 3: Copy chính xác nội dung chuyển tiền để được cộng tiền tự động (viết liền không có dấu cách)
        <br />
        Bước 4: Chờ khoảng 1-2 phút reload lại trang số dư sẽ được cập nhật.
        <br />
        <strong style="color:red;">Lưu ý : Nếu ghi sai ID hoặc quá 5 phút chưa nhận tiền vui lòng nhắn page góc phải màn hình để được hỗ trợ.</strong>
      </p>
      <p class="deposit-des-txt" v-else>
        <span v-html="website.popup_bank_content"></span>
      </p>
    </div>
    <!-- <b-button class="mt-3" block @click="$bvModal.hide('depositViaMOMO')">Đóng</b-button> -->
  </b-modal>
</template>

<script>
export default {
  props: {
    user: {
      Type: Object,
      default() {
        return {};
      },
    },
    website: {
      Type: Object,
      default() {
        return {};
      },
    },
    settings: {
      Type: Object,
      default() {
        return {};
      },
    },
  },
  data() {
    return {
      value_send: null,
      create_qr_code: '',
      add_info: '',
    };
  },

  methods: {
    async copyToClipBoard(myText) {
      await navigator.clipboard.writeText(myText);
      this.$swal.fire({
        timer: 1000,
        icon: "success",
        title: "Copy thành công",
        showConfirmButton: false,
        width: '400px',
      });
    },

    refreshTransCode() {
      this.create_qr_code = null;
      this.add_info = null;
    },

    async createQrBank() {
      let value_send = parseInt(this.value_send);

      if (value_send >= 10000 && value_send <= 10000000) {
        if (this.website.toggle_payment_code) {
          const uri = this.route('fe_create_transaction', {domain: this.website.domain});
          const response = await this.Request.post(uri, {
            value: value_send,
          });

          if (response.data.status === true) {
            this.add_info = response.data.message;
            this.create_qr_code = `https://img.vietqr.io/image/${this.website.bank_name.toLowerCase()}-${this.website.bank_number}-compact.jpg?amount=${value_send}&addInfo=${this.add_info}`;
          }
        }
      } else {
        this.create_qr_code = null;
        this.add_info = null;
        this.$swal.fire({
          timer: 4000,
          icon: "error",
          title: 'Vui lòng nhập số tiền',
          html: 'Vui lòng nhập số tiền tối thiểu ít nhất là <b><u>10.000đ</u></b> và nhiều nhất là <b><u>10.000.000đ</u></b>',
          showConfirmButton: false,
          width: '400px',
        });
      }
    },

    async checkDepositSuccess() {
      try {
        const uri = this.route('fe_check_deposit', {domain: this.website.domain});
        const response = await this.Request.post(uri, {
          add_info: this.add_info,
        });

        if (response.data.status === false) {
          await this.$swal.fire({
            icon: "warning",
            title: 'Thông báo',
            html: response.data.message,
            timer: 5000,
            showConfirmButton: false,
          });
        } else {
          await this.$swal.fire({
            icon: "success",
            title: 'Thành công',
            html: response.data.message,
            timer: 5000,
          }).then((result) => {
              if (result.isConfirmed) {
                window.location.reload();
              }
          });
        }
      } catch (error) {
        await this.$swal.fire({
          icon: "error",
          title: 'Error!',
          html: error,
        });
      }
    },
  },
}
</script>

<style scoped></style>
